import React from 'react';
import './collapse.css';
import SecondaryCustomButton from "../../../components/accesories/customBtn/SecondaryCustomButton";
import {NavLink} from "react-router-dom";
import useHandleRequest from "../../../custom_hooks/useHandleRequest";

function Collapse({showNavbar, closeNavbar}) {
    const {handleRequestAndNavigate} = useHandleRequest();

    return (
        <div className={`navbar-collapse ${showNavbar && 'show'}`} id="navbarNav">
            <ul>
                <li className="nav-item dropdown" onClick={closeNavbar}><NavLink to={'/'} className={'nav-link'}
                                                                                 onClick={(e) => handleRequestAndNavigate(e, '/', '/', 'home')}>خانه</NavLink>
                </li>
                <li className="nav-item dropdown" onClick={closeNavbar}><NavLink to={'/events'}
                                                                                 className={'nav-link'}>رویدادها</NavLink>
                </li>
                <li className="nav-item dropdown" onClick={closeNavbar}><NavLink to={'/projects'} className={'nav-link'}
                                                                                 onClick={(e) => handleRequestAndNavigate(e, '/projects', 'projects/', 'projects')}>پروژه‌ها</NavLink>
                </li>
                <li className="nav-item dropdown" onClick={closeNavbar}><NavLink to={'/blogs'} className={'nav-link'}
                                                                                 onClick={(e) => handleRequestAndNavigate(e, '/blogs', 'blogs/', 'blogs')}>وبلاگ</NavLink>
                </li>
                <li className="nav-item dropdown" onClick={closeNavbar}><NavLink to={'/faq'} className={'nav-link'}>پرسش‌های
                    متداول</NavLink></li>
                <li className="nav-item dropdown" onClick={closeNavbar}><NavLink to={'/about_us'} className={'nav-link'}
                                                                                 onClick={(e) => handleRequestAndNavigate(e, '/about-us', 'about-us/', 'about_us')}>درباره
                    ما</NavLink></li>
                <li className="nav-item dropdown" onClick={closeNavbar}><NavLink to={'/contact-us'}
                                                                                 className={'nav-link'}
                                                                                 onClick={(e) => handleRequestAndNavigate(e, '/contact-us', 'contact-us/', 'contact_us')}>تماس
                    با ما</NavLink></li>
            </ul>
        </div>
    );
}

export default Collapse;